<template>
  <li
    v-show="visible"
    class="s-select-dropdown__item"
    :class="{
      'selected': itemSelected,
      'is-wrap': wrap,
      'is-disabled': disabled || groupDisabled || limitReached,
      'hover': hover
    }"
    :data-qa="dataQa"
    @click.prevent.stop="selectOptionClick"
    @mouseenter="hoverItem">
    <slot>
      <span
        v-if="labelByQuery"
        v-dompurify-html="labelByQuery"/>
      <span v-else> {{ currentLabel }} </span>
    </slot>
  </li>
</template>

<script>
import emitter from '../../mixins/emitter'
import { getValueByPath, escapeRegexpString } from '../../utils/util'
/**
 * @displayName Select item
 * @ignore
 */
export default {
  mixins: [emitter],
  name: 'sOption',
  componentName: 'sOption',
  //inject: ['select'],
  inject: {
    select: {
      default: {}
    }
  },
  props: {
    /**
     * Значение опции
     */
    value: {
      type: [String, Number, Object, Boolean],
      //required: true
    },
    /**
     * метка опции, то же самое, что и `value`, если не указано
     */
    label: [String, Number],
    /**
     * Переносить строки
     */
    wrap: {
      type: Boolean,
      default: true
    },    
    /**
     * @ignore
     */
    created: Boolean,
    /**
     * отключена ли опция
     */
    disabled: {
      type: Boolean,
      default: false
    },
    dataQa: {
      type: String,
      default: 'select-item'
    }
  },
  data() {
    return {
      index: -1,
      groupDisabled: false,
      visible: true,
      hitState: false,
      hover: false,
      labelByQuery: null,
    }
  },
  computed: {
    isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]'
    },
    currentLabel() {
      return this.label || (this.isObject ? '' : this.value)
    },
    currentValue() {
      return this.value || this.label || ''
    },
    itemSelected() {
      if (!this.select.multiple) {
        return this.isEqual(this.value, this.select.value)
      } else {
        return this.contains(this.select.value, this.value)
      }
    },
    limitReached() {
      if (this.select.multiple) {
        return !this.itemSelected &&
            (this.select.value || []).length >= this.select.multipleLimit &&
            this.select.multipleLimit > 0
      } else {
        return false
      }
    }
  },
  watch: {
    currentLabel() {
      if (!this.created && !this.select.remote) { this.dispatch('sSelect', 'setSelected') }
    },
    value(val, oldVal) {
      const { remote, valueKey } = this.select
      if (!this.created && !remote) {
        if (valueKey && typeof val === 'object' && typeof oldVal === 'object' && val[valueKey] === oldVal[valueKey]) {
          return
        }
        this.dispatch('sSelect', 'setSelected')
      }
    }
  },
  methods: {
    isEqual(a, b) {
      if (!this.isObject) {
        return a === b
      } else {
        const valueKey = this.select.valueKey
        return getValueByPath(a, valueKey) === getValueByPath(b, valueKey)
      }
    },
    contains(arr = [], target) {
      if (!this.isObject) {
        return arr && arr.indexOf(target) > -1
      } else {
        const valueKey = this.select.valueKey
        return arr && arr.some(item => {
          return getValueByPath(item, valueKey) === getValueByPath(target, valueKey)
        })
      }
    },
    handleGroupDisabled(val) {
      this.groupDisabled = val
    },
    hoverItem() {
      if (!this.disabled && !this.groupDisabled) {
        this.select.hoverIndex = this.select.options?.indexOf(this)
      }
    },
    selectOptionClick() {
      if (this.disabled !== true && this.groupDisabled !== true) {
        this.dispatch('sSelect', 'handleOptionClick', [this, true])
      }
    },
    queryChange(query) {
      const getHighlightedText = (text, higlight) => {
        let groups = higlight.split(' ').map(v => `(${v})`).join('|')
        return '<span style="color:var(--v-secondary__green_not_active-base);">' + text.replace(new RegExp(groups, 'gi'), g => `<b style="color:var(--black-color)">${g}</b>`) + '<span>'
      }

      this.visible = new RegExp(escapeRegexpString(query), 'i').test(this.currentLabel) || this.created
      if (!this.visible) {
        this.select.filteredOptionsCount--
        this.labelByQuery = null
      } else if (query && query !== this.select.currentPlaceholder) {
        this.labelByQuery = getHighlightedText(this.currentLabel, query)
      } else {
        this.labelByQuery = null
      }
    }
  },
  created() {
    this.select.options?.push(this)
    this.select.cachedOptions?.push(this)
    this.select.optionsCount++
    this.select.filteredOptionsCount++
    this.$on('queryChange', this.queryChange)
    this.$on('handleGroupDisabled', this.handleGroupDisabled)
  },
  beforeDestroy() {
    const { selected, multiple } = this.select
    let selectedOptions = multiple ? selected : [selected]
    let index = this.select.cachedOptions?.indexOf(this)
    let selectedIndex = selectedOptions.indexOf(this)
    if (index > -1 && selectedIndex < 0) {
      this.select.cachedOptions?.splice(index, 1)
    }
    this.select.onOptionDestroy(this.select.options?.indexOf(this))
  }
}
</script>